
import '../../../style.css';
import star from '../../../assets/star.png';
import check from '../../../assets/check.png';
import nene from '../../../assets/nene.png';
import checkgray from '../../../assets/checkgray.png';

import Modal from 'react-modal';
import { useSelector } from 'react-redux';
import { Doughnut } from 'react-chartjs-2';
import { useEffect, useState } from 'react';

import DoneMilestone from '../DoneMilestone';
import { Milestone } from '../../../interfaces/progress';
import NextMilestone from '../NextMilestone';
import ProgressByArea from '../ProgressByArea';
import Alerts from '../Alerts';
import Loader from '../../../components/Loader';
import { customStyles2 } from '../../../theme/global';
import AnswerInModal from '../AnswerInModal';


Modal.setAppElement('#root');

const data = {
    labels: [],
    datasets: [],
};

type ChartData ={
    labels: any[],
    datasets: any[]
}

const weekDays = [
    {id:"1", name: "SEG"},
    {id:"2", name: "TER"},
    {id:"3", name: "QUA"},
    {id:"4", name: "QUI"},
    {id:"5", name: "SEX"},
    {id:"6", name: "SAB"},
    {id:"7", name: "DOM"},
]

const MilestonesReportPortuguese = () => {

    const state = useSelector( (state:any) => state.milestones);
    const [dataGrafico, setDataGrafico] = useState<ChartData>(data);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);
    const [showModal, setShowModal] = useState(false);

    const {
        done_milestones,
        next_milestones,
        failed_milestones,
        progress,
        total_stage_milestones,
        interactions
    } = state;

    useEffect(() => {
        const data1 = progress.map((item:any) => ({
            labels: item.area.name,
            values: Number((item.completed * 100) / total_stage_milestones).toFixed(0)
        }));
        const data2 = {
            labels: data1.map((item:any) => item.labels),
            datasets: [{
                label: 'Progresso por área',
                data: data1.map((item:any) => item.values),
                backgroundColor: [
                    '#00FFFF',
                    '#34A853',
                    '#F1C232',
                ],
                borderColor: [
                    '#00FFFF',
                    '#34A853',
                    '#F1C232',
                ],
                borderWidth: 1
            }]
        }
        setDataGrafico(data2);
        const calculateTotal = data1.reduce((acc:any, current:any) => acc + Number(current.values), 0);
        setTotal(calculateTotal);
        setTimeout(() => {
            setLoading(false);
        },1500)
    },[total_stage_milestones, progress])

    return (
        <div className="page">

            <div className="container">
                <div className="row">
                    <div className="col-sm-4">
                        <div className="baby-info-content">
                            <div>
                                <img src={nene} alt="" width="180" height="auto"
                                className="baby-img"/>
                            </div>
                            <div className="baby-name">
                                <h4>{state.instance_name}</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-8">
                        <div className="info-etapa">
                            <div className="row my-3">
                                <div className="col-sm-9">
                                    <h5 className="etapa-pre-title custom-font">Etapa</h5>
                                    <h3 className="etapa-title custom-font">{state.stage.name}</h3>
                                </div>
                                <div className="col-sm-3">
                                    <img src={state.stage.image_url} alt="" width="90" height="auto"
                                    className="img-etapa"/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <p className="etapa-text custom-font">{state.stage.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="separador"></div>
                <div className="row">
                    <div className="col-sm-9">
                        <h3 className="custom-font etapa-title mb-3">SUA SEMANA NA AFINI</h3>
                        <div className="row">
                            <div className="col-sm-2">
                                <div className="d-flex justify-content-center align-items-center"
                                style={{height: "100%"}}>
                                    <img src={star} alt="" width="90" height="auto" style={{transform: "rotate(90deg)"}}/>
                                </div>
                            </div>
                            <div className="col-sm-10">
                                <div className="row">
                                    {weekDays.map((item: any) => (
                                        <div className="col" key={item.id}>
                                            <div>
                                                <h4 className="custom-font text-center week-day">{item.name}</h4>
                                                <img src={interactions.includes(item.id) ? check : checkgray} alt="" className="check-mark"/>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <p className="my-4 custom-font text-center" style={{fontSize: 22, color: "#545454"}}>{interactions.length} Dias que você usou a Afini nesta semana</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div style={{ backgroundColor: "#eaf6f6", padding: '20px', borderRadius: "10px", boxShadow: '0 0  5px 0 rgba(0,0,0,.2)'}}>
                            <h2 style={{color: "#80cc28"}} className="custom-font">¡Parabéns!</h2>
                            <p className="custom-font" style={{ color: "#09b5ee", fontSize: 20}}>Você usou Afini com bastante frequência. Continue assim!</p>
                        </div>
                    </div>
                </div>
                <div className="separador"></div>
                <div className="row">
                    <div className="col-sm-12">
                        <h3 className="custom-font mb-4 text-center" style={{ color: "#09b5ee"}}>OBJETIVOS CONQUISTADOS NA ETAPA: {state.stage.name}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="p-1">
                            <h3 className="custom-font" style={{ color: "#7ed957",fontWeight: 600}}>¡PARABÉNS!</h3>
                            <p style={{color: "#737373", fontWeight: 400, fontSize: 18}}
                            className="custom-font">Estamos indo muito bem nos seguintes objetivos</p>
                            {done_milestones.length > 0 ? (
                               done_milestones.map((item:Milestone, idx: number) => <DoneMilestone item={item} key={idx}/>)
                            ) : (
                                <div className="alert alert-info">não há informações para mostrar</div>
                            )}

                        </div>
                    </div>
                    <div className="col-sm-6" style={{ borderLeft: '3px solid grey'}}>
                        <div className="p-21">
                            <h3 style={{ color: "#f4717f", fontWeight: 600}}
                            className="custom-font">¡CONTINUE AVANÇANDO!</h3>
                            <div className="row">
                                <div className="col-sm-12">
                                    <p
                                    style={{color: "#737373", fontWeight: 400, fontSize: 18}}
                                    className="custom-font">
                                        Nos seguintes objetivos
                                    </p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    {failed_milestones.length > 0 ? (
                                        failed_milestones.map((item:Milestone, idx: number) => <NextMilestone item={item} key={idx} />)
                                    ): (
                                        <div className="alert alert-info">não há informações para mostrar</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr />
                <div className="row mb-4 mt-4 pt-2">
                    <div className="col-sm-12 text-center">
                        <button className="btn btn-outline-primary mb-3 custom-font" type="button"
                        onClick={() => setShowModal(true)}
                        style={{borderRadius: '50px'}}>Mudar as respostas</button>
                        <p style={{ color: 'grey'}}
                        className="custom-font">Se você quiser alterar alguma de suas respostas, pressione o botão</p>
                    </div>
                </div>
                <hr />

                <div className="row mt-4">
                    <div className="col-sm-6">
                        {loading ? (
                            <Loader />
                        ) : (
                            <>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h3 className="custom-font mb-3"
                                        style={{color: '#737373'}}>SEU PROGRESSO</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div style={{ display: "flex", height: "100%", justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                                            <h1 className="text-center custom-font"
                                            style={{fontSize: '60px', fontWeight:400, color: '#737373'}}
                                            >{total}%</h1>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <Doughnut data={dataGrafico} />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="col-sm-6">
                        <div className="d-flex justify-content-center" style={{ flexDirection: 'column', padding: '40px 0'}}>
                            <ProgressByArea items={progress} lang="pt"/>
                        </div>
                    </div>
                </div>
                <div className="separador"></div>
                <div className="row">
                    <div className="col-sm-12">
                        <h3
                        className="custom-font"
                        style={{ color: "#F1C232", fontSize: 40}}>¡Vamos trabalhar em!!</h3>
                        {next_milestones.length > 0 ? (
                            next_milestones.map((item: Milestone, idx: any) => <Alerts item={item} key={idx}/>)
                        ) : (
                            <div className="alert alert-info">não há informações para mostrar</div>
                        )}
                    </div>
                </div>
                <div className="separador"></div>
            </div>

            <Modal
                isOpen={showModal}
                onRequestClose={()=> setShowModal(false)}
                style={customStyles2}
                contentLabel="Example Modal"
            >
                <AnswerInModal onClose={() => {
                    window.location.reload();
                    setShowModal(false);
                }}
                lang="pt"/>
            </Modal>
        </div>
    )
}

export default MilestonesReportPortuguese
